import { AuthClient } from '@/api/auth-client'
import { RealworksAgendaStatus } from '@/api/types'
import { RealworksTaakStatus } from '@/api/types'
import { Company } from '@/api/model/company'
import { Branch } from '@/api/model/branch'
import { User } from '@/api/model/user'
import { MedewerkerWithUser } from '@/api/realworks-types'
import { cloneDeep } from 'lodash'
import { Contact } from '@/api/model/contact'

export const RealworksAPI = new class RealworksClient extends AuthClient {

    async getAgendatypes() {
        const response = await this.client.get(`/api/v1/service/realworks/agendatypes`, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

    async getAgendaStatussen(): Promise<RealworksAgendaStatus[]> {
        const response = await this.client.get(`/api/v1/service/realworks/agenda_statussen`, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

    async getTaaktypes() {
        const response = await this.client.get(`/api/v1/service/realworks/taaktypes`, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

    async getRelatietypes() {
        const response = await this.client.get(`/api/v1/service/realworks/relatietypes`, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

    async getTaakStatussen(): Promise<RealworksTaakStatus[]> {
        const response = await this.client.get(`/api/v1/service/realworks/taak_statussen`, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data
    }

    async importMedewerkers(company: Company): Promise<void> {
        const response = await this.client.post(`/api/v1/service/realworks/medewerker/import`, {
            company: company.id,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })
    }

    async getMedewerkersWithUser(): Promise<MedewerkerWithUser[]> {
        const response = await this.client.get(`/api/v1/service/realworks/medewerker/with_user`, {
            headers: {
                Accept: 'application/json',
            },
        })

        const medewerkersWithUser = response.data
        medewerkersWithUser.forEach(medewerkerWithUser => {
            medewerkerWithUser.user = User.fromData(medewerkerWithUser.user)
        })

        return medewerkersWithUser
    }

    async getMedewerkerWithUser(id: string): Promise<MedewerkerWithUser[]> {
        const response = await this.client.get(`/api/v1/service/realworks/medewerker/${id}/with_user`, {
            headers: {
                Accept: 'application/json',
            },
        })

        const medewerkerWithUser = response.data
        medewerkerWithUser.user = User.fromData(medewerkerWithUser.user)

        return medewerkerWithUser
    }

    async createUsersForMedewerkers(mapping: {[key: string]: { role: string, branches: Branch[]}}, informUsers: boolean): Promise<void> {
        const mappingData = cloneDeep<any>(mapping)

        Object.keys(mappingData).forEach(medewerkerId => {
            if (!mappingData[medewerkerId].role) {
                delete mappingData[medewerkerId]
                return
            }

            mappingData[medewerkerId].branches = mappingData[medewerkerId].branches.map(branch => branch.id)
        })

        const response = await this.client.post(`/api/v1/service/realworks/medewerker/create_users`, {
            mapping: mappingData,
            informUsers,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })
    }

    async getContactFromRelatie(relatieId: string): Promise<Contact|null> {
        const response = await this.client.post(`/api/v1/service/realworks/contact_from_relatie`, {
            relatieId,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data.contact
            ? Contact.fromData(response.data.contact)
            : null
    }
}()
